import React from 'react';
import { useAppSelector } from '../../store/hooks';

interface AdminStatCardProps {
  label: string;
  value: string | number;
  icon: any;
  color?: string;
}

const AdminStatCard: React.FC<AdminStatCardProps> = ({ label, value, icon: Icon, color }) => {
  const colors = useAppSelector((state) => state.theme.theme);
  const accent = color || colors.primary;

  return (
    <div
      className="rounded-xl p-5 flex items-center gap-4"
      style={{ backgroundColor: colors.cardBackground || colors.backgroundColor, boxShadow: colors.shadowSoft }}
    >
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
        style={{ backgroundColor: `${accent}20` }}
      >
        {React.createElement(Icon as any, { size: 22, color: accent })}
      </div>
      <div>
        <p className="text-2xl font-bold" style={{ color: colors.textColor }}>{value}</p>
        <p className="text-xs mt-0.5" style={{ color: colors.grayScale500 }}>{label}</p>
      </div>
    </div>
  );
};

export default AdminStatCard;
